<template>
  <div :class="{'m-card': !isInCard, 'm-card-incard': isInCard, 'm-card--elite': data.ShowStatus === 1, fz15: true}">
    <div class="m-card-header">
      <a :href="data.UserHomeUrl">
        <div class="m-avatar" v-if="!isInCard">
          <img :src="data.UserHeadUrl">
        </div>
        <span class="fz15 m-avatar--name">
          {{data.UserName}}
        </span>
      </a>
      <span v-if="isHost" class="fz11 m-avatar-name--host">主持人</span>
    </div>
    <div class="m-card-body">
      <h4 v-if="data.PostTitle">{{data.PostTitle}}</h4>
      <div v-if="filteredContentLength > 100 && openAllShow">
        <span v-html="filteredContent.substring(0, 100)" class="fz16"></span>
        ...<a href="javascript:;" @click="openAll" class="c-blue">全文</a>
      </div>
      <div v-else>
        <span v-html="filteredContent" class="fz15"></span> <a href="javascript:;" @click="closeAll" class="c-blue" v-if="filteredContentLength > 100 && !openAllShow">收起</a>
      </div>
      <sq-card-images :imgs="imgLists" v-if="imgLists.length > 0 && !videoSrc"></sq-card-images>
      <sq-card-video :src="videoSrc" v-if="videoSrc"></sq-card-video>
    </div>
    <slot></slot>
    <div class="m-card-footer">
      <a :href="postHref" v-if="data.IsPost" class="fz13 m-card-actions--post">查看原帖</a>
      <a
        v-if="!data.IsPost"
        href="javascript:;"
        :class="['m-card-actions--favor', 'fz13', {'m-card-actions--favored': isFavored}]"
        @click="handlePraise"
        ><span v-show="!isFavored">赞</span><span v-show="favoredCount && isFavored">{{favoredCount}}</span></a>
      <a
        v-if="!data.IsPost"
        href="javascript:;"
        class="m-card-actions--reply fz13"
        @click="reply">回复</a>
    </div>
  </div>
</template>

<script>
import CardImages from './cardImages'
import CardVideo from './cardVideo'

import {parseContent, parseVideo} from '@/utils/filter'
import {imgStr2Arr, inOtherBroswer, isLogin} from '@/utils/index'

import hhkjsq from '@/common/hhkjsq.js'
const {hosts} = hhkjsq
export default {
  components: {
    'sq-card-images': CardImages,
    'sq-card-video': CardVideo
  },

  data () {
    return {
      openAllShow: true
    }
  },

  props: {
    data: {
      type: Object
    },
    isInCard: {
      type: Boolean
    },
    showDate: {
      type: Boolean
    }
  },

  computed: {
    postHref () {
      return hosts.nodomain + '/shuo/detail/' + this.data.PostID
    },
    imgLists () {
      if (this.data.ImagePath) {
        return imgStr2Arr(this.data.ImagePath)
      }
      return []
    },
    videoSrc () {
      // 不是帖子且不是主持人的信息不解析视频
      if (!this.data.IsPost &&
        (this.data.UserName !== (this.data.TopicUserName || this.$store.state.header.PrensenterName))) {
        return null
      }
      return parseVideo(this.data.CommentContent)
    },
    isFavored () {
      const praiseInfo = this.$store.state.list.praiseCountList
      if (praiseInfo[this.data.CommentID]) {
        return !praiseInfo[this.data.CommentID].isShow
      }
      return false
    },
    isHost () {
      return this.data.TopicUserName === this.data.UserName
    },
    favoredCount () {
      const praiseInfo = this.$store.state.list.praiseCountList
      if (praiseInfo[this.data.CommentID]) {
        return praiseInfo[this.data.CommentID].count
      }
      return undefined
    },
    filteredContent () {
      return parseContent(this.data.CommentContent, this.data.PostID).content
    },
    filteredContentLength () {
      // return this.data.CommentContent.length
      return parseContent(this.data.CommentContent, this.data.PostID).length
    }
  },

  methods: {
    parseContent: parseContent,
    parseVideo: parseVideo,
    imgStr2Arr: imgStr2Arr,
    reply () {
      if (inOtherBroswer()) return
      if (isLogin()) {
        var preCommentInfo = Object.assign({}, this.data, {PreCommentInfo: null})
        var preComment = {
          preCommentID: this.data.CommentID,
          preCommentInfo: preCommentInfo
        }
        this.$store.dispatch('showCommentArea', preComment)
      }
    },
    handlePraise () {
      if (inOtherBroswer()) return
      if (isLogin()) {
        this.$store.dispatch('handlePraise', this.data)
      }
    },
    openAll () {
      this.openAllShow = false
    },
    closeAll () {
      this.openAllShow = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// cardItem.vue?118c102f